/** Web Share / clipboard helper for tracks and releases (link preview via OG). */

export type SharePayload = {
  title: string;
  text?: string;
  url: string;
};

export function absoluteUrl(pathOrUrl: string): string {
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  if (typeof window === 'undefined') return pathOrUrl;
  return new URL(pathOrUrl, window.location.origin).href;
}

/** Share via system sheet when available; otherwise copy the URL.
 * No artwork file — messengers use the page OG image (release cover via
 * middleware for crawlers + setPageMeta in the app).
 */
export async function shareContent(
  payload: SharePayload,
): Promise<'shared' | 'copied' | 'cancelled'> {
  const url = absoluteUrl(payload.url);
  const data: ShareData = {
    title: payload.title,
    text: payload.text,
    url,
  };

  if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
    try {
      await navigator.share(data);
      return 'shared';
    } catch (err) {
      const name = err instanceof Error ? err.name : '';
      if (name === 'AbortError') return 'cancelled';
      // Fall through to clipboard.
    }
  }
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(url);
    return 'copied';
  }
  return 'cancelled';
}
